import { lazy } from 'react';

const LazyUnauthorizedPage = lazy(() => import('./unauthorized-page'));
export default LazyUnauthorizedPage;
